import { render } from "./add.vue?vue&type=template&id=0818d056"
import script from "./add.vue?vue&type=script&lang=js"
export * from "./add.vue?vue&type=script&lang=js"

import "./add.vue?vue&type=style&index=0&id=0818d056&lang=less"
script.render = render

export default script